const Calendar = (props) => (
  <svg width="14px" height="14px" className="icon-calendar" viewBox="0 0 14 14" version="1.1" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="molecule/delivery-info/default" transform="translate(-81.000000, -13.000000)" fill="#E67C21">
        <g id="calendar-icon" transform="translate(81.000000, 13.000000)">
          <path d="M11.9,12.6 L2.1,12.6 C1.68,12.6 1.4,12.32 1.4,11.9 L1.4,4.2 L12.6,4.2 L12.6,11.9 C12.6,12.32 12.32,12.6 11.9,12.6 M2.1,1.4 L11.9,1.4 C12.32,1.4 12.6,1.68 12.6,2.1 L12.6,2.8 L1.4,2.8 L1.4,2.1 C1.4,1.68 1.68,1.4 2.1,1.4 M11.9,0 L2.1,0 C0.91,0 0,0.91 0,2.1 L0,11.9 C0,13.09 0.91,14 2.1,14 L11.9,14 C13.09,14 14,13.09 14,11.9 L14,2.1 C14,0.91 13.09,0 11.9,0" id="Fill-1"></path>
          <polygon id="Fill-3" points="6.3 7.56 7.7 7.56 7.7 6.16 6.3 6.16"></polygon>
          <polygon id="Fill-5" points="3.5 7.56 4.9 7.56 4.9 6.16 3.5 6.16"></polygon>
          <polygon id="Fill-6" points="9.1 7.56 10.5 7.56 10.5 6.16 9.1 6.16"></polygon>
          <polygon id="Fill-7" points="3.5 10.36 4.9 10.36 4.9 8.96 3.5 8.96"></polygon>
          <polygon id="Fill-8" points="6.3 10.36 7.7 10.36 7.7 8.96 6.3 8.96"></polygon>
          <polygon id="Fill-9" points="9.1 10.36 10.5 10.36 10.5 8.96 9.1 8.96"></polygon>
        </g>
      </g>
    </g>
  </svg>
);

export default Calendar;